import Backbone from 'backbone';
import ko from 'knockout';
import _ from 'underscore';

import errorOnClickTemplate from './error-on-click-template.pug';

/*
A custom view that displays a warning under an option
when a passed in predicate is not met
*/
export class BaseErrorOnClickView extends Backbone.View {
  initialize({
    observable,
    field,
    predicate,
    errorMessage,
    blockCheckInput,
  }) {
    this.viewModel = {
      observable,
      displayErrorMessage: ko.observable(false),
    };
    this.field = field;
    this.predicate = predicate;
    this.errorMessage = errorMessage;
    this.blockCheckInput = blockCheckInput;

    // delegate events here because events() is run before blockCheckInput and field are received
    if (this.blockCheckInput) {
      const events = {};
      events[`click [id=${this.field.id}]`] = 'onClick';
      this.delegateEvents(events);
    }
  }

  onClick() {
    if (!this.predicate()) {
      if (this.blockCheckInput) this.viewModel.observable(false);
      this.viewModel.displayErrorMessage(true);
    } else {
      this.viewModel.displayErrorMessage(false);
    }
  }

  render() {
    this.$el.html(errorOnClickTemplate({
      field: this.field,
      errorMessage: this.errorMessage,
    }));

    ko.applyBindings(this.viewModel, this.el);
    return this;
  }
}

export function createErrorOnClickWithDependentFieldClass(
  errorMessage,
  dependentFieldName,
  blockCheckInput = true
) {
  return class ErrorOnClickView extends BaseErrorOnClickView {
    constructor({ observable, viewModel, field }) {
      super({
        observable,
        field,
        predicate: _.propertyOf(viewModel)(dependentFieldName),
        errorMessage,
        blockCheckInput,
      });
    }
  };
}
